<!-- <body> -->
    <div class="content">
        <div class="container-fluid">
            <div class="content box_shadow table_container">
                <span class="graphtitledata">Employee Exit Report</span>
                <hr>
                <div class="exit-report-toolbar">

                    <input type="text " class="input " (input)="onQuickFilterChanged($event)" placeholder="Search..." />
                    <span class="">Employee Exit Month :</span>
                    <select class="month-year-select" [value]="selectedMonthYear" (change)="onMonthYearChange($event)"
                        aria-label="Select month and year">
                        <option *ngFor="let month of monthYearOptions" [value]="month.value">{{ month.label }}</option>
                    </select>
                    <span class="excel_sheet-wrap" [class.excel_sheet-wrap--disabled]="!canExportExcel"
                        (click)="onBtExport()" [attr.aria-disabled]="!canExportExcel" role="button"
                        aria-label="Download Excel">
                        <img src="../../assets/image/vscode-icons_file-type-excel.svg" class="excel_sheet" alt="" />
                    </span>
                </div>
                <!-- <input type="text " class="input " (input)="onQuickFilterChanged($event)" placeholder="Search..." /> -->
                <ag-grid-angular class="table_list" [rowData]="rowData" [pinnedTopRowData]="pinnedTopRowData"
                    [columnDefs]="colDefs" [defaultColDef]="defaultColDef" [quickFilterText]="quickFilter"
                    [defaultExcelExportParams]="defaultExcelExportParams" (gridReady)="onGridReady($event)" />
            </div>
        </div>
    </div>
<!-- </body> -->

<!-- Loading -->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>